export const numberFormatter = ({ number, precise = 1 }: any) => {
  const num = Number(number).toFixed(precise);
  return Number(num).toLocaleString();
};
